import styles from './popover.module.scss';
import MaterialPopover from '@mui/material/Popover';

/* eslint-disable-next-line */
export interface PopoverProps {
  open: boolean,
  // action?: any,
  anchorEl?: any,
  anchorOrigin?: {
    horizontal: 'center' | 'left' | 'right' | number,
    vertical: 'bottom' | 'center' | 'top' | number
  },
  // anchorPosition?: { left: number, top: number },
  // anchorReference?: 'anchorEl' | 'anchorPosition' | 'none',
  children?: any,
  // classes?: object,
  // container?: any,
  // elevation?: number,
  // marginThreshold?: number,
  onClose?: any,
  // PaperProps?: any,
  // sx?: any,
  // transformOrigin?: {
  //   horizontal: 'center' | 'left' | 'right' | number,
  //   vertical: 'bottom' | 'center' | 'top' | number
  // },
  // TransitionComponent?: any,
  // transitionDuration?: 'auto' | number | { appear?: number, enter?: number, exit?: number },
  // TransitionProps?: object,
  id?: any
}

export function Popover(props: PopoverProps) {
  return (
    <MaterialPopover
      open={props.open}
      onClose={props.onClose}
      anchorOrigin={props.anchorOrigin}
      id={props.id}
      anchorEl={props.anchorEl}>
      {props.children}
    </MaterialPopover>
  );
}

export default Popover;